module.exports = __webpack_public_path__ + "img/4_no.cd22724c.svg";